import {
  businessCenterIconv1,
  commandCenterIcon,
  keapMaxIcon,
  marketingCenterIconv1,
  reportingCenterIconv1,
  workforceCenterIconv1,
} from '../../../../assets'
import {
  getCountryRegistry,
  getPaymentMethodValues,
  subscribeToCountryRegistry,
} from '../../../../utils/country-registry'

export const dataJSON = {}

export const VALIDITY_IN_HOUR_IN_MS = 3601000

export const NON_ADDED_PLANS = [
  'addon-5-signatures_usage',
  'app-websitebuilder',
  'cc_basicpls-5-thryv-m2m',
  'thryvprfee',
]

export const PAYMENT_METHODS = [
  {name: 'Card', value: 'card', icon: 'creditCard'},
  {name: 'Bank Transfer with ACH', value: 'ach', icon: 'landmark'},
]

export const AUS_PAYMENT_METHODS = [
  {name: 'Card', value: 'card', icon: 'creditCard'},
  {name: 'BECS', value: 'becs', icon: 'landmark'},
]

// Backend-driven (country registry, see src/utils/country-registry.js). Updated
// IN PLACE when the registry loads so every importer sees the new list.
const toCountryOptions = () =>
  getCountryRegistry().map(({name, iso}) => ({name, value: iso}))

export const COUNTRIES = toCountryOptions()

subscribeToCountryRegistry(() => {
  COUNTRIES.splice(0, COUNTRIES.length, ...toCountryOptions())
})

// Payment methods offered for a country (registry paymentMethods, default
// card-only; ACH is US-only and BECS is AU-only).
export const getPaymentMethods = countryCode =>
  getPaymentMethodValues(countryCode)
    .map(value =>
      value === 'becs'
        ? AUS_PAYMENT_METHODS[1]
        : PAYMENT_METHODS.find(m => m.value === value),
    )
    .filter(Boolean)

export {OOE_SERVICE_URL as REACT_APP_OOE_SERVICE_URL} from '../../../../utils/api-base'
export const ONE_TIME_FEES = [
  '5 extra website pages',
  'professional designed logo',
  'onboarding fee',
  'website design fee',
  'custom video shoot',
  'thryv ignite implementation',
  'advanced crm data import',
  'advanced data transfer',
  'ask the expert',
  'basic crm data import',
  'credit card import',
  'data restore',
  'e-commerce data import',
  'e-commerce data transfer',
  'hourly data service',
  'limited e-commerce crm import',
  'custom done for you',
  'thryv vertical services',
  'thryv vertical and mc services & design',
  'thryv vertical and mc services',
  'vertical and mc services & design',
  'vertical and mc services',
  'vertical services',
]

export const INITIAL_PAYMENT_STATE = {
  paymentMethod: PAYMENT_METHODS[0],
  paymentInfo: undefined,
  calculatedTaxes: null,
  totalPaymentAmount: 0,
  totalPaymentAmountNoTaxes: 0,
  semiAnnuallyAmount: 0,
  monthlyAmount: 0,
  oneTimeAmount: 0,
  monthlyAddons: [],
  semiAnnuallyAddons: [],
  oneTimeAddons: [],
  taxes: {
    monthly: null,
    semiAnnually: null,
    oneTime: null,
  },
}

export const MC_2_0_PLANS = [
  'mc_starter-5-thryv-m2m',
  'mc_prov2-5-thryv-m2m',
  'mc_premier-5-thryv-m2m',
  'starter-5-thryv-annual',
  'signature-5-thryv-annual',
  'premier-5-thryv-annual',
  'signature_plus-5-thryv-m2m',
  'signature_plus-5-thryv-annual',
]

export const PLANS_ICONS = [
  {
    name: 'my account',
    icon: commandCenterIcon,
  },
  {
    name: 'business center',
    icon: businessCenterIconv1,
  },
  {
    name: 'marketing center',
    icon: marketingCenterIconv1,
  },
  {
    name: 'reporting center',
    icon: reportingCenterIconv1,
  },
  {
    name: 'workforce center',
    icon: workforceCenterIconv1,
  },
  {
    name: 'keap max',
    icon: keapMaxIcon,
  },
]
